module.exports = __webpack_public_path__ + "img/graphics-6.f8ff8746.svg";